import { render, staticRenderFns } from "./Mutation.vue?vue&type=template&id=222293d7&scoped=true"
import script from "./Mutation.vue?vue&type=script&lang=js"
export * from "./Mutation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222293d7",
  null
  
)

export default component.exports